import React, { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const LocationInput = ({ id, label, placeholder, value, onChange, onClear, onSelectSuggestion, suggestions, isLoading, fetchSuggestions, isSelected }) => {
  const [showSuggestions, setShowSuggestions] = useState(true);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (value && !isSelected) {
        setShowSuggestions(true);
        fetchSuggestions(value);
      } else {
        setShowSuggestions(false);
      }
    }, 150);
    return () => clearTimeout(handler);
  }, [value, isSelected, fetchSuggestions]);

  const handleSelect = (suggestion) => {
    onSelectSuggestion(suggestion);
    setShowSuggestions(false);
  };

  const handleInputChange = (e) => {
    onChange(e.target.value);
    if (!showSuggestions) {
      setShowSuggestions(true);
    }
  };

  return (
    <div className="relative">
      <Label htmlFor={id} className="text-base sm:text-lg">{label}</Label>
      <div className="relative mt-2">
        <Input
          id={id}
          name={id}
          placeholder={placeholder}
          className="h-10 sm:h-12 text-sm sm:text-lg"
          value={value}
          onChange={handleInputChange}
          onClear={onClear}
          required
          autoComplete="off"
          aria-describedby={`${id}-suggestions`}
        />
      </div>
      {isLoading && <div className="absolute top-full left-0 w-full p-2 text-center text-xs sm:text-sm text-gray-400">Loading...</div>}
      {showSuggestions && !isSelected && (
        <ul id={`${id}-suggestions`} className="absolute z-20 w-full bg-brand-charcoal border border-brand-gold/50 rounded-md mt-1 max-h-48 sm:max-h-60 overflow-y-auto shadow-lg" role="listbox" aria-label={`${label} suggestions`}>
          {suggestions.length === 0 && (
            <li className="px-3 sm:px-4 py-2 text-gray-400 text-sm sm:text-base">Keep typing to search…</li>
          )}
          {suggestions.map(s => (
            <li key={s.place_id} className="px-3 sm:px-4 py-2 cursor-pointer hover:bg-brand-gold/20 text-sm sm:text-base" onClick={() => handleSelect(s)} role="option" aria-selected="false">
              {s.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationInput;